import React, { useState } from "react";
import { format, isAfter, startOfDay, parse } from "date-fns";

import { FormGroup, Label, ErrorMessage } from "./styles";
import Button from "../Button/button";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";
import InputComponent from "../Input/input";

interface AbrirCaixaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (valorAbertura: number, dataCaixa: Date) => void;
}

const AbrirCaixaModal: React.FC<AbrirCaixaModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [valorAbertura, setValorAbertura] = useState<string>("R$0,00");
  const [dataCaixa, setDataCaixa] = useState<string>(
    format(new Date(), "yyyy-MM-dd")
  );
  const [dataError, setDataError] = useState<string>("");

  const validarData = (data: string): boolean => {
    try {
      const dataParseada = parse(data, "dd/MM/yyyy", new Date());
      const hoje = startOfDay(new Date());

      if (isAfter(hoje, dataParseada)) {
        setDataError("Não é permitido abrir caixa com data passada");
        return false;
      }

      setDataError("");
      return true;
    } catch (error) {
      setDataError("Data inválida");
      return false;
    }
  };

  const handleDataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const novaData = e.target.value;
    setDataCaixa(novaData);
    validarData(novaData);
  };

  const limparModal = () => {
    setValorAbertura("R$0,00");
    setDataError("");
  };

  const handleConfirm = () => {
    // Remove caracteres não numéricos
    const valor = valorAbertura.replace("R$", "").replace(",", ".").trim();
    // if (isNaN(valor) || valor < 0) {
    //   return;
    // }
    if (!validarData(dataCaixa)) {
      return;
    }

    // // Fuso horário de São Paulo
    // const fusoHorario = "America/Sao_Paulo";

    // // Parse da data no formato dd/MM/yyyy
    // const dataParseada = parse(dataCaixa, "dd/MM/yyyy", new Date());

    // // Obtém a data e hora atual no fuso horário de São Paulo
    // const agora = new Date();
    // const agoraEmSaoPaulo = toZonedTime(agora, fusoHorario);
    // const teste = new Date(
    //   dataParseada.getFullYear(),
    //   dataParseada.getMonth(),
    //   dataParseada.getDate(),
    //   12, // Set hour to 12
    //   0,  // Set minutes to 0
    //   0,  // Set seconds to 0
    //   0   // Set milliseconds to 0
    // );
    // // Combina a data do caixa com a hora atual no fuso horário correto
    // const dataComHora = new Date(
    //   dataParseada.getFullYear(),
    //   dataParseada.getMonth(),
    //   dataParseada.getDate(),
    //   agoraEmSaoPaulo.getHours(),
    //   agoraEmSaoPaulo.getMinutes(),
    //   agoraEmSaoPaulo.getSeconds(),
    //   agoraEmSaoPaulo.getMilliseconds()
    // );

    const newDate = new Date(dataCaixa);
    onConfirm(Number(valor), newDate);
    onClose();
    limparModal();
  };

  if (!isOpen) return null;

  return (
    <ModalContainer show={isOpen}>
      <ModalContent width={25}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Abrir caixa</BlueTitle>
        </ModalHeader>

        <ModalBody>
          <FormGroup>
            <Label>Data do caixa</Label>
            <InputComponent
              type="date"
              name="dataAbertura"
              id="dataAbertura"
              value={dataCaixa}
              onChange={handleDataChange}
              placeholder="DD/MM/YYYY"
              color="black"
            />
            {dataError && <ErrorMessage>{dataError}</ErrorMessage>}
          </FormGroup>

          {/* <FormGroup>
            <Label>Valor de abertura</Label>
            <InputComponent
              type="text"
              name="valorAbertura"
              id="valorAbertura"
              value={valorAbertura}
              onChange={(e) => {
                // Remove any non-numeric characters except decimal point
                const formatted = e.target.value
                  .replace(/\D/g, "")
                  .replace(/(\d)(\d{2})$/, "$1,$2")
                  .replace(/(?=(\d{3})+(\D))\B/g, ".");
                setValorAbertura("R$ " + formatted);
                //setValorAbertura(formatted);
              }}
              placeholder="R$ 0,00"
              color="black"
            />
          </FormGroup> */}
        </ModalBody>
        <ModalFooter>
          <Button action={onClose} schemaButton="out-danger">
            Cancelar
          </Button>
          <Button
            action={handleConfirm}
            disabled={!!dataError}
            schemaButton="full-primary"
          >
            Abrir Caixa
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default AbrirCaixaModal;
